<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showRecommendation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #267d26">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: User Name Input -->
          <base-input
            type="text"
            col="12"
            :placeholder="$t('SIDENAV.Clients.name')"
            v-model="data.user.name"
            disabled
          />
          <!-- End:: User Name Input -->

          <!-- Start:: Recommendations Repeater -->
          <div class="col-12">
            <h6 class="mt-3 mb-2">{{ $t("PLACEHOLDERS.recommendations") }}</h6>
            <div
              class="row align-items-center mb-2"
              v-for="(item, index) in displayRecommendations"
              :key="index"
            >
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.recommendation_list')"
                v-model="item.recommendations_list_name"
                disabled
              />
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.influencer_name')"
                v-model="item.influencer_name"
                disabled
              />
            </div>
          </div>
          <!-- End:: Recommendations Repeater -->

          <!-- Start:: Created At Input -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model="data.created_at"
            disabled
          />
          <!-- End:: Created At Input -->

          <!-- Start:: Total Recommended Input -->
          <base-input
            type="text"
            col="6"
            :placeholder="$t('PLACEHOLDERS.total_recommended')"
            v-model="data.total_recommended"
            disabled
          />
          <!-- End:: Total Recommended Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowRecommendation",

  data() {
    return {
      // Start:: Data Collection To Send
      data: {
        user: {
          name: null,
        },
        created_at: null,
        total_recommended: null,
      },
      displayRecommendations: [],
      // End:: Data Collection To Send
    };
  },

  methods: {
    // start show data
    async showRecommendation() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `recommendations/${this.$route.params.id}`,
        });

        const recommendation = res.data.data.Recommendation;

        // Map User
        this.data.user = recommendation.user;
        this.data.created_at = recommendation.created_at;
        this.data.total_recommended = recommendation.total_recommended;

        // Map Recommendations from flat structure
        this.displayRecommendations = [];

        if (
          recommendation.recommendations &&
          recommendation.recommendations.length > 0
        ) {
          recommendation.recommendations.forEach((item) => {
            this.displayRecommendations.push({
              recommendations_list_name: item.recommendations_list?.name,
              influencer_name: item.influencer?.name,
            });
          });
        }
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // end show data
  },

  created() {
    this.showRecommendation();
  },
};
</script>
